import { required } from "vuelidate/lib/validators";

export default class MetaData {
  valor = 0;
  id_meta = null;
  constructor({
    valor = 0,
    id_meta = null
  }) {
    this.valor = valor;
    this.id_meta = id_meta;
  }
}